import { mapGetters } from 'vuex'

export default {
  props: {
    isSSORegister: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapGetters('registration', [
      'registrationEmail',
      'registrationPrimarySms',
      'registrationPrimaryVoice',
    ]),
    ...mapGetters('member', ['memberSsoContactInfo']),
    coalesceContactInfo() {
      if (this.isSSORegister) {
        return {
          email: this.memberSsoContactInfo.email,
          primaryPhone: this.memberSsoContactInfo.primaryPhone,
          primarySmsPhone: this.memberSsoContactInfo.primarySmsPhone,
        }
      }

      return {
        email: this.registrationEmail,
        primaryPhone: this.registrationPrimaryVoice,
        primarySmsPhone: this.registrationPrimarySms,
      }
    },
  },
}
